/**
 * Entity containing metadata info
 * @class
 */
export class FormEntity {
  private name: string;
  private value: any;

  /**
   * Sets the data value
   * @param {any} data The data passed in as a FormEntity
   * @returns {void}
   */
  constructor(data) {
    if (data) {
      data.hasOwnProperty('full_name') && this.setName(data.full_name);
      if (data.hasOwnProperty('value')) {
        this.setValue(data.value);
      }
      else {
        this.setValue(data);
      }
    }
    else {
      this.setName('');
      this.setValue(null);
    }
  }

  /**
   * Gets the name
   * @returns {string}
   */
  getName(): string {
    return this.name;
  }

  /**
   * Sets the name
   * @param {string} value The value to be set
   * @returns {void}
   */
  setName(value: string) {
    this.name = value;
  }

  /**
   * Gets the value
   * @returns {any}
   */
  getValue(): any {
    return this.value;
  }

  /**
   * Sets the value
   * @param {any} value The value to be set
   * @returns {void}
   */
  setValue(value: any) {
    this.value = value;
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/entities/FormEntity.ts